<template>
  <div class="row justify-content-center align-items-center">
    <div class="col-lg-6 col-md-6 col-sm-12">
      <div v-if="loggedOut">
        <div class="alert alert-danger" role="alert">
          U bent uitgelogd. Log opnieuw in om de app te blijven gebruiken.
        </div>
      </div>
      <div class="card">
        <img
            src="@/../assets/images/logo.png" alt="Logo"
            class="card-img-top">
        <div class="card-header">
          <h2>Welkom bij de Pulse app</h2>
        </div>
        <div class="card-body">
          <form novalidate>
            <div class="form-group">
              <b-button class="btn-fill-pulse" @click="oAuth2Google" v-if="!backendAuthenticated">Aanmelden met Google</b-button>
            </div>
            <div class="form-group">
            </div>
            <div class="form-group">
              <b-button class="btn-fill-pulse" @click="oAuth2Apple">Aanmelden met Apple</b-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: 'Login',
  data() {
    return {};
  },
  computed: {
    ...mapGetters("authentication", ["backendAuthenticated"]),
    ...mapGetters({
      loggedOut: "authentication/loggedOut"
    })

  },
  async created() {
    if (this.backendAuthenticated) {
      this.redirectDefaultStartPage();
    }
    let urlPath = this.$route.query;
    if (urlPath.token) {
      await this.setAuthentication(urlPath.token);
      this.redirectDefaultStartPage();
    } else if (urlPath.error) {
      this.setErrorMessage(urlPath.error);

      await this.$router.push(this.$route.path);
    }
  },
  methods: {
    oAuth2Google() {
      this.$router.push('googleOauthEndPoint');
    },
    oAuth2Apple() {
      this.$router.push('appleOauthEndpoint');
    },
    ...mapActions("authentication", ["setAuthentication", "redirectDefaultStartPage"]),
    ...mapMutations({
      setErrorMessage: "setErrorMessage"
    })
  },
};
</script>

<style scoped>
img {
  padding: 1em
}

.row {
  height: 80vh
}

.form-group button {
  width: 230px;
}
</style>
